var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _g4, _path9, _g5, _g6, _path0, _path1, _g7, _path10, _path11, _g8, _path12, _g9, _path13, _g0, _g1, _path14, _path15, _g10, _path16, _path17, _g11, _path18, _g12, _path19, _g13, _path20, _g14, _path21, _path22, _g15, _path23, _path24, _g16, _path25, _g17, _path26, _g18, _path27, _g19, _path28, _path29, _g20, _path30, _path31, _g21, _path32, _g22, _path33, _g23, _path34, _g24, _g25, _path35, _g26, _g27, _path36, _g28, _path37, _path38, _g29, _path39, _path40, _g30, _path41, _g31, _path42, _path43, _g32, _path44, _path45, _g33, _path46, _g34, _path47, _path48, _g35, _path49, _g36, _path50, _g37, _g38, _path51, _path52, _g39, _path53, _g40, _path54, _g41, _g42, _path55, _path56, _g43, _path57, _g44, _path58, _path59, _g45, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiraffeOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_181193)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_197_181193)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.728 321C223.588 321 268.061 314.983 268.061 307.56C268.061 300.138 223.588 294.121 168.728 294.121C113.868 294.121 69.3945 300.138 69.3945 307.56C69.3945 314.983 113.868 321 168.728 321Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.88 254.953C228.365 255.801 220.728 253.621 213.698 248.355C208.365 244.299 203.395 238.427 199.94 230.557L193.031 234.007C197.395 243.088 203.455 249.687 209.88 254.166C218.728 260.281 228.183 262.278 234.849 261.007L233.88 254.953Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 230,
    width: 42,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.88 254.953C228.365 255.801 220.728 253.621 213.698 248.355C208.365 244.299 203.395 238.427 199.94 230.557L193.031 234.007C197.395 243.088 203.455 249.687 209.88 254.166C218.728 260.281 228.183 262.278 234.849 261.007L233.88 254.953Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.547 238.063C198.183 240.848 200.85 243.391 203.092 245.631C209.335 251.806 216.547 256.285 224.85 258.344C227.092 258.888 229.395 259.554 231.759 259.615C231.941 259.615 232.425 260.22 232.547 260.341C233.274 260.947 234.001 261.431 234.789 261.855C237.092 263.126 239.577 263.731 242.183 263.61C247.759 263.429 252.365 260.22 256.001 255.983C257.213 254.59 258.365 253.137 259.516 251.624C259.941 251.019 260.425 250.353 260.85 249.747C260.91 249.687 261.213 249.202 261.335 249.323C261.577 249.626 261.031 250.655 260.91 250.958C260.244 252.714 259.456 254.348 258.547 255.983C254.789 262.642 248.85 267.666 241.274 268.332C237.88 268.635 234.425 268.09 231.335 266.698C229.698 265.971 228.244 264.64 226.607 264.034C223.698 262.944 220.547 262.823 217.638 261.673C208.486 257.98 199.819 250.897 194.789 242.059L196.547 238.063Z",
    fill: "#CE8710"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.182 264.518C229.515 263.428 224.364 256.769 230.303 252.592C238.121 247.022 245.758 251.381 249.454 248.718C249.091 250.715 246.909 253.016 242 254.711C241.515 254.892 244 254.65 244.424 254.59C246.97 254.166 249.03 252.713 250.788 250.957C254.788 247.022 256.424 247.688 256.364 247.749C252.909 252.108 251.515 256.466 250.121 258.101C244.667 264.578 239.636 265.85 234.182 264.518Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 247,
    width: 30,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.182 264.518C229.515 263.428 224.364 256.769 230.303 252.592C238.121 247.022 245.758 251.381 249.454 248.718C249.091 250.715 246.909 253.016 242 254.711C241.515 254.892 244 254.65 244.424 254.59C246.97 254.166 249.03 252.713 250.788 250.957C254.788 247.022 256.424 247.688 256.364 247.749C252.909 252.108 251.515 256.466 250.121 258.101C244.667 264.578 239.636 265.85 234.182 264.518Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.334 238.305C204.364 240.605 206.243 242.845 207.819 244.782C212.182 250.17 217.576 254.287 224.061 256.769C225.819 257.435 227.637 258.161 229.455 258.403C229.576 258.403 229.94 258.948 230.001 259.009C230.485 259.553 231.091 259.977 231.637 260.401C233.334 261.612 235.334 262.338 237.395 262.52C241.879 262.944 245.94 260.946 249.273 258.04C250.364 257.071 251.455 256.103 252.485 255.074C252.91 254.65 253.334 254.166 253.758 253.742C253.819 253.681 254.122 253.379 254.182 253.439C254.304 253.681 253.758 254.468 253.698 254.65C253.031 255.921 252.182 257.132 251.273 258.282C247.637 263.004 242.304 266.273 236.182 266.031C233.455 265.91 230.728 265.183 228.364 263.791C227.092 263.065 226.122 261.914 224.788 261.248C222.546 260.098 220.061 259.735 217.819 258.524C210.849 254.771 204.546 248.475 201.395 241.089L203.334 238.305Z",
    fill: "#301007"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.453 307.742C157.453 307.742 156.787 269.967 163.453 250.716L123.635 237.034C115.393 261.068 115.332 308.105 115.332 308.105L157.453 307.742Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 237,
    width: 49,
    height: 72
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.453 307.742C157.453 307.742 156.787 269.967 163.453 250.716L123.635 237.034C115.393 261.068 115.332 308.105 115.332 308.105L157.453 307.742Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.362 308.045C120.605 295.574 121.877 261.068 128.605 241.635L162.605 253.319C162.847 252.411 163.15 251.563 163.453 250.716L123.635 237.034C115.393 261.068 115.332 308.105 115.332 308.105L120.362 308.045Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 237,
    width: 49,
    height: 72
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.453 307.742C157.453 307.742 156.787 269.967 163.453 250.716L123.635 237.034C115.393 261.068 115.332 308.105 115.332 308.105L157.453 307.742Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.394 281.832C139.697 281.59 138.122 282.74 137.879 284.436C137.637 286.131 138.788 287.705 140.485 287.947C142.182 288.189 143.758 287.039 144 285.344C144.303 283.649 143.091 282.075 141.394 281.832ZM126.728 265.124C122.788 265.124 119.637 268.272 119.637 272.207C119.637 276.081 122.788 279.29 126.728 279.29C130.667 279.29 133.819 276.142 133.819 272.207C133.819 268.272 130.667 265.124 126.728 265.124Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 265,
    width: 26,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 265,
    width: 26,
    height: 23
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.394 281.832C139.697 281.59 138.122 282.74 137.879 284.436C137.637 286.131 138.788 287.705 140.485 287.947C142.182 288.189 143.758 287.039 144 285.344C144.303 283.649 143.091 282.075 141.394 281.832ZM126.728 265.124C122.788 265.124 119.637 268.272 119.637 272.207C119.637 276.081 122.788 279.29 126.728 279.29C130.667 279.29 133.819 276.142 133.819 272.207C133.819 268.272 130.667 265.124 126.728 265.124Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.453 307.742C157.453 307.742 156.787 269.967 163.453 250.716L123.635 237.034C115.393 261.068 115.332 308.105 115.332 308.105L157.453 307.742Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.362 308.045C120.605 295.574 121.877 261.068 128.605 241.635L162.605 253.319C162.847 252.411 163.15 251.563 163.453 250.716L123.635 237.034C115.393 261.068 115.332 308.105 115.332 308.105L120.362 308.045Z",
    fill: "#C3A088"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M115.941 308.892C115.153 308.892 114.426 308.469 114.002 307.803C113.578 307.137 113.578 306.289 113.941 305.563C117.699 298.964 127.76 294.121 138.002 294.121C148.547 294.121 156.123 299.206 158.911 306.108C159.153 306.713 159.093 307.439 158.729 307.984C158.366 308.529 157.76 308.832 157.093 308.832C148.972 308.892 124.729 308.892 115.941 308.892Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 294,
    width: 47,
    height: 15
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M115.941 308.892C115.153 308.892 114.426 308.469 114.002 307.803C113.578 307.137 113.578 306.289 113.941 305.563C117.699 298.964 127.76 294.121 138.002 294.121C148.547 294.121 156.123 299.206 158.911 306.108C159.153 306.713 159.093 307.439 158.729 307.984C158.366 308.529 157.76 308.832 157.093 308.832C148.972 308.892 124.729 308.892 115.941 308.892Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.305 303.505C112.85 304.352 113.82 304.897 114.911 304.897C125.214 304.897 149.274 304.897 158.668 304.837C159.517 304.837 160.305 304.473 160.79 303.808C161.093 304.231 161.335 304.655 161.577 305.079C162.002 305.866 162.002 306.834 161.517 307.621C161.032 308.408 160.183 308.893 159.214 308.893C149.577 308.953 124.729 308.953 114.183 308.953C113.032 308.953 111.941 308.287 111.456 307.319C110.911 306.29 111.032 305.139 111.759 304.231C111.941 303.929 112.123 303.747 112.305 303.505Z",
    fill: "#301007"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.941 307.742C179.941 307.742 180.608 269.967 173.941 250.716L213.76 237.034C222.002 261.068 222.063 308.105 222.063 308.105L179.941 307.742Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 237,
    width: 50,
    height: 72
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.941 307.742C179.941 307.742 180.608 269.967 173.941 250.716L213.76 237.034C222.002 261.068 222.063 308.105 222.063 308.105L179.941 307.742Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.032 308.045C216.79 295.574 215.517 261.068 208.79 241.635L174.79 253.319C174.547 252.411 174.244 251.563 173.941 250.716L213.76 237.034C222.002 261.068 222.063 308.105 222.063 308.105L217.032 308.045Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 237,
    width: 50,
    height: 72
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.941 307.742C179.941 307.742 180.608 269.967 173.941 250.716L213.76 237.034C222.002 261.068 222.063 308.105 222.063 308.105L179.941 307.742Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.67 281.832C196.366 281.59 197.942 282.74 198.185 284.436C198.427 286.131 197.276 287.705 195.579 287.947C193.882 288.189 192.306 287.039 192.063 285.344C191.821 283.649 192.973 282.075 194.67 281.832ZM209.336 265.124C213.276 265.124 216.427 268.272 216.427 272.207C216.427 276.081 213.276 279.29 209.336 279.29C205.397 279.29 202.245 276.142 202.245 272.207C202.245 268.272 205.397 265.124 209.336 265.124Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 265,
    width: 25,
    height: 23
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 265,
    width: 25,
    height: 23
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M194.666 281.832C196.363 281.59 197.938 282.74 198.181 284.436C198.423 286.131 197.272 287.705 195.575 287.947C193.878 288.189 192.302 287.039 192.06 285.344C191.817 283.649 192.969 282.075 194.666 281.832ZM209.332 265.124C213.272 265.124 216.423 268.272 216.423 272.207C216.423 276.081 213.272 279.29 209.332 279.29C205.393 279.29 202.241 276.142 202.241 272.207C202.241 268.272 205.393 265.124 209.332 265.124Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.938 307.742C179.938 307.742 180.604 269.967 173.938 250.716L213.756 237.034C221.998 261.068 222.059 308.105 222.059 308.105L179.938 307.742Z",
    fill: "white"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.028 308.045C216.786 295.574 215.513 261.068 208.786 241.635L174.786 253.319C174.544 252.411 174.241 251.563 173.938 250.716L213.756 237.034C221.998 261.068 222.059 308.105 222.059 308.105L217.028 308.045Z",
    fill: "#301007"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M221.455 308.892C222.243 308.892 222.97 308.469 223.394 307.803C223.819 307.137 223.819 306.289 223.455 305.563C219.697 298.964 209.637 294.121 199.394 294.121C188.849 294.121 181.273 299.206 178.485 306.108C178.243 306.713 178.303 307.439 178.667 307.984C179.031 308.529 179.637 308.832 180.303 308.832C188.485 308.892 212.667 308.892 221.455 308.892Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 294,
    width: 46,
    height: 15
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.455 308.892C222.243 308.892 222.97 308.469 223.394 307.803C223.819 307.137 223.819 306.289 223.455 305.563C219.697 298.964 209.637 294.121 199.394 294.121C188.849 294.121 181.273 299.206 178.485 306.108C178.243 306.713 178.303 307.439 178.667 307.984C179.031 308.529 179.637 308.832 180.303 308.832C188.485 308.892 212.667 308.892 221.455 308.892Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.092 303.505C224.546 304.352 223.576 304.897 222.485 304.897C212.182 304.897 188.122 304.897 178.728 304.837C177.879 304.837 177.092 304.473 176.607 303.808C176.304 304.231 176.061 304.655 175.819 305.079C175.395 305.866 175.395 306.834 175.879 307.621C176.364 308.408 177.213 308.893 178.182 308.893C187.819 308.953 212.667 308.953 223.213 308.953C224.364 308.953 225.455 308.287 225.94 307.319C226.425 306.35 226.364 305.139 225.637 304.231C225.516 303.929 225.273 303.747 225.092 303.505Z",
    fill: "#301007"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0312 165.176C73.0312 165.176 108.243 195.445 150.001 184.609L144.849 164.632C113.152 172.804 86.5464 149.558 86.5464 149.558L73.0312 165.176Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 149,
    width: 77,
    height: 38
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0312 165.176C73.0312 165.176 108.243 195.445 150.001 184.609L144.849 164.632C113.152 172.804 86.5464 149.558 86.5464 149.558L73.0312 165.176Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1211 168.688C68.1211 168.688 98.6059 199.38 144.788 188.847L141.879 178.192C107.818 186.728 77.2726 162.513 77.2726 162.513L68.1211 168.688Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 149,
    width: 77,
    height: 38
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0312 165.176C73.0312 165.176 108.243 195.445 150.001 184.609L144.849 164.632C113.152 172.804 86.5464 149.558 86.5464 149.558L73.0312 165.176Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.576 161.302C106.364 163.905 107.455 166.992 110.061 168.263C112.667 169.474 115.758 168.384 117.03 165.781C118.243 163.178 117.152 160.091 114.546 158.82C111.879 157.609 108.788 158.698 107.576 161.302Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 149,
    width: 77,
    height: 38
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0312 165.176C73.0312 165.176 108.243 195.445 150.001 184.609L144.849 164.632C113.152 172.804 86.5464 149.558 86.5464 149.558L73.0312 165.176Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3627 165.358C91.393 167.416 92.1809 169.898 94.1809 170.807C96.1809 171.715 98.5445 170.807 99.5749 168.688C100.545 166.629 99.7567 164.147 97.7567 163.239C95.7567 162.331 93.3324 163.239 92.3627 165.358Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 149,
    width: 77,
    height: 38
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0312 165.176C73.0312 165.176 108.243 195.445 150.001 184.609L144.849 164.632C113.152 172.804 86.5464 149.558 86.5464 149.558L73.0312 165.176Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.455 173.349C118.728 174.923 119.395 176.739 120.91 177.465C122.425 178.192 124.304 177.526 125.031 176.012C125.758 174.438 125.092 172.622 123.576 171.896C122.061 171.109 120.183 171.775 119.455 173.349Z",
    fill: "#673620"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8188 165.6C57.4551 160.03 53.94 138.963 67.94 137.207C72.7885 136.602 79.5763 141.929 82.243 146.288C81.8188 144.411 81.8188 139.629 84.8491 140.658C86.0612 141.082 88.1824 145.501 88.3036 151.071C85.6369 157.366 79.1521 164.631 73.8188 165.6Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 137,
    width: 30,
    height: 29
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8188 165.6C57.4551 160.03 53.94 138.963 67.94 137.207C72.7885 136.602 79.5763 141.929 82.243 146.288C81.8188 144.411 81.8188 139.629 84.8491 140.658C86.0612 141.082 88.1824 145.501 88.3036 151.071C85.6369 157.366 79.1521 164.631 73.8188 165.6Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1212 165.903C82.6667 165.479 69.9394 160.273 68 157.125C62.7273 152.282 59.7576 144.412 68.7273 135.937C55.9394 136.724 52 147.862 52 147.862L72.9091 172.259L86.1212 165.903Z",
    fill: "#301007"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M228.668 221.84C228.668 221.84 200.304 182.308 184.789 171.835L196.365 155.611C213.456 167.174 245.213 210.458 245.213 210.458L228.668 221.84Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 155,
    width: 62,
    height: 67
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M228.668 221.84C228.668 221.84 200.304 182.308 184.789 171.835L196.365 155.611C213.456 167.174 245.213 210.458 245.213 210.458L228.668 221.84Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.91 227.53C224.91 227.53 186.365 180.795 170.91 170.382L179.88 161.302C196.971 172.864 233.334 220.568 233.334 220.568L224.91 227.53Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 155,
    width: 62,
    height: 67
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M228.668 221.84C228.668 221.84 200.304 182.308 184.789 171.835L196.365 155.611C213.456 167.174 245.213 210.458 245.213 210.458L228.668 221.84Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.394 193.387C226.909 194.779 223.697 193.932 222.303 191.389C220.909 188.907 221.818 185.699 224.303 184.306C226.788 182.914 230 183.761 231.394 186.304C232.788 188.846 231.879 191.994 229.394 193.387Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 155,
    width: 62,
    height: 67
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M228.668 221.84C228.668 221.84 200.304 182.308 184.789 171.835L196.365 155.611C213.456 167.174 245.213 210.458 245.213 210.458L228.668 221.84Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.424 208.824C224.424 209.974 221.879 209.308 220.848 207.432C219.757 205.555 220.545 203.073 222.545 201.923C224.545 200.773 227.091 201.438 228.121 203.315C229.212 205.252 228.485 207.674 226.424 208.824Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 155,
    width: 62,
    height: 67
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M228.668 221.84C228.668 221.84 200.304 182.308 184.789 171.835L196.365 155.611C213.456 167.174 245.213 210.458 245.213 210.458L228.668 221.84Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.545 182.429C215.03 183.277 213.151 182.732 212.303 181.279C211.454 179.826 212 177.889 213.515 177.102C215.03 176.254 216.909 176.799 217.757 178.252C218.545 179.705 218 181.582 216.545 182.429Z",
    fill: "#673620"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M244.91 210.216C259.698 218.207 259.456 238.608 245.637 237.942C240.85 237.7 235.213 231.525 233.456 226.985C233.516 228.801 232.728 233.341 229.94 231.828C228.85 231.222 227.577 226.743 228.425 221.476C232.062 215.967 239.637 210.216 244.91 210.216Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 210,
    width: 28,
    height: 28
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M244.91 210.216C259.698 218.207 259.456 238.608 245.637 237.942C240.85 237.7 235.213 231.525 233.456 226.985C233.516 228.801 232.728 233.341 229.94 231.828C228.85 231.222 227.577 226.743 228.425 221.476C232.062 215.967 239.637 210.216 244.91 210.216Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.486 216.754C230.365 216.633 234.547 220.689 235.819 224.018C240.789 236.005 252.486 240.605 257.456 227.529C256.85 238.729 245.274 242.966 238.728 241.635C231.88 240.182 226.728 234.249 224.789 227.59C224.001 224.926 223.638 221.899 224.547 219.175L230.486 216.754Z",
    fill: "#301007"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M202.364 156.641H135.031C127.273 182.793 121.273 208.764 121.273 226.441C121.273 257.557 142.425 273.781 168.607 273.781C194.789 273.781 216.122 257.618 216.122 226.441C216.122 208.824 210.122 182.853 202.364 156.641Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 156,
    width: 96,
    height: 118
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M202.364 156.641H135.031C127.273 182.793 121.273 208.764 121.273 226.441C121.273 257.557 142.425 273.781 168.607 273.781C194.789 273.781 216.122 257.618 216.122 226.441C216.122 208.824 210.122 182.853 202.364 156.641Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.849 156.641H135.031C127.273 182.793 121.273 208.764 121.273 226.441C121.273 240.243 125.455 252.896 132.425 262.703C128.486 253.864 126.243 243.694 126.243 232.858C126.243 215.302 131.94 183.943 140.849 156.641Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 156,
    width: 96,
    height: 118
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.364 156.641H135.031C127.273 182.793 121.273 208.764 121.273 226.441C121.273 257.557 142.425 273.781 168.607 273.781C194.789 273.781 216.122 257.618 216.122 226.441C216.122 208.824 210.122 182.853 202.364 156.641Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.547 156.641H202.365C210.123 182.793 216.123 208.764 216.123 226.441C216.123 240.243 211.941 252.896 204.971 262.703C208.911 253.864 211.153 243.694 211.153 232.858C211.153 215.302 205.456 183.943 196.547 156.641Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 156,
    width: 96,
    height: 118
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M202.364 156.641H135.031C127.273 182.793 121.273 208.764 121.273 226.441C121.273 257.557 142.425 273.781 168.607 273.781C194.789 273.781 216.122 257.618 216.122 226.441C216.122 208.824 210.122 182.853 202.364 156.641Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.363 240.667C137.696 240.667 135.515 242.907 135.515 245.692C135.515 248.477 137.696 250.717 140.363 250.717C143.03 250.717 145.212 248.477 145.212 245.692C145.212 242.907 143.03 240.667 140.363 240.667ZM198.06 240.97C200.666 240.97 202.727 242.907 202.727 245.329C202.727 247.75 200.606 249.687 198.06 249.687C195.454 249.687 193.393 247.75 193.393 245.329C193.333 242.968 195.454 240.97 198.06 240.97ZM210.242 223.475C213.151 223.475 215.454 225.775 215.454 228.681C215.454 231.526 213.09 233.887 210.242 233.887C207.333 233.887 205.03 231.587 205.03 228.681C204.969 225.775 207.333 223.475 210.242 223.475ZM125.696 221.961C122.787 221.961 120.484 224.262 120.484 227.167C120.484 230.013 122.848 232.374 125.696 232.374C128.606 232.374 130.909 230.073 130.909 227.167C130.909 224.262 128.545 221.961 125.696 221.961ZM199.515 212.638C201.212 212.638 202.606 214.031 202.606 215.726C202.606 217.421 201.212 218.813 199.515 218.813C197.818 218.813 196.424 217.421 196.424 215.726C196.424 214.031 197.757 212.638 199.515 212.638ZM136.727 210.156C135.03 210.156 133.636 211.549 133.636 213.244C133.636 214.939 135.03 216.331 136.727 216.331C138.424 216.331 139.818 214.939 139.818 213.244C139.818 211.488 138.424 210.156 136.727 210.156ZM208.666 188.181C212.606 188.181 215.757 191.329 215.757 195.264C215.757 199.138 212.606 202.347 208.666 202.347C204.727 202.347 201.575 199.199 201.575 195.264C201.575 191.329 204.727 188.181 208.666 188.181ZM128.303 188.181C124.363 188.181 121.212 191.329 121.212 195.264C121.212 199.138 124.363 202.347 128.303 202.347C132.242 202.347 135.393 199.199 135.393 195.264C135.393 191.329 132.242 188.181 128.303 188.181ZM195.818 178.616C197.515 178.616 198.909 180.009 198.909 181.704C198.909 183.399 197.515 184.791 195.818 184.791C194.121 184.791 192.727 183.399 192.727 181.704C192.727 180.009 194.121 178.616 195.818 178.616ZM141.151 178.616C139.454 178.616 138.06 180.009 138.06 181.704C138.06 183.399 139.454 184.791 141.151 184.791C142.848 184.791 144.242 183.399 144.242 181.704C144.242 180.009 142.848 178.616 141.151 178.616Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 178,
    width: 95,
    height: 73
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 178,
    width: 96,
    height: 73
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.363 240.666C137.696 240.666 135.515 242.906 135.515 245.691C135.515 248.476 137.696 250.716 140.363 250.716C143.03 250.716 145.212 248.476 145.212 245.691C145.212 242.906 143.03 240.666 140.363 240.666ZM198.06 240.969C200.666 240.969 202.727 242.906 202.727 245.328C202.727 247.749 200.606 249.686 198.06 249.686C195.454 249.686 193.393 247.749 193.393 245.328C193.333 242.967 195.454 240.969 198.06 240.969ZM210.242 223.474C213.151 223.474 215.454 225.774 215.454 228.68C215.454 231.525 213.09 233.886 210.242 233.886C207.333 233.886 205.03 231.586 205.03 228.68C204.969 225.774 207.333 223.474 210.242 223.474ZM125.696 221.96C122.787 221.96 120.484 224.261 120.484 227.166C120.484 230.012 122.848 232.373 125.696 232.373C128.606 232.373 130.909 230.072 130.909 227.166C130.909 224.261 128.545 221.96 125.696 221.96ZM199.515 212.637C201.212 212.637 202.606 214.03 202.606 215.725C202.606 217.42 201.212 218.812 199.515 218.812C197.818 218.812 196.424 217.42 196.424 215.725C196.424 214.03 197.757 212.637 199.515 212.637ZM136.727 210.155C135.03 210.155 133.636 211.548 133.636 213.243C133.636 214.938 135.03 216.33 136.727 216.33C138.424 216.33 139.818 214.938 139.818 213.243C139.818 211.487 138.424 210.155 136.727 210.155ZM208.666 188.18C212.606 188.18 215.757 191.328 215.757 195.263C215.757 199.138 212.606 202.346 208.666 202.346C204.727 202.346 201.575 199.198 201.575 195.263C201.575 191.328 204.727 188.18 208.666 188.18ZM128.303 188.18C124.363 188.18 121.212 191.328 121.212 195.263C121.212 199.138 124.363 202.346 128.303 202.346C132.242 202.346 135.393 199.198 135.393 195.263C135.393 191.328 132.242 188.18 128.303 188.18ZM195.818 178.615C197.515 178.615 198.909 180.008 198.909 181.703C198.909 183.398 197.515 184.79 195.818 184.79C194.121 184.79 192.727 183.398 192.727 181.703C192.727 180.008 194.121 178.615 195.818 178.615ZM141.151 178.615C139.454 178.615 138.06 180.008 138.06 181.703C138.06 183.398 139.454 184.79 141.151 184.79C142.848 184.79 144.242 183.398 144.242 181.703C144.242 180.008 142.848 178.615 141.151 178.615Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.364 156.64H135.031C127.273 182.792 121.273 208.763 121.273 226.44C121.273 257.556 142.425 273.78 168.607 273.78C194.789 273.78 216.122 257.617 216.122 226.44C216.122 208.823 210.122 182.852 202.364 156.64Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.547 156.64H202.365C210.123 182.792 216.123 208.763 216.123 226.44C216.123 240.242 211.941 252.895 204.971 262.702C208.911 253.863 211.153 243.693 211.153 232.857C211.153 215.301 205.456 183.942 196.547 156.64Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 178,
    width: 95,
    height: 73
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 178,
    width: 96,
    height: 73
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.363 240.666C137.696 240.666 135.515 242.906 135.515 245.691C135.515 248.476 137.696 250.716 140.363 250.716C143.03 250.716 145.212 248.476 145.212 245.691C145.212 242.906 143.03 240.666 140.363 240.666ZM198.06 240.969C200.666 240.969 202.727 242.906 202.727 245.328C202.727 247.749 200.606 249.686 198.06 249.686C195.454 249.686 193.393 247.749 193.393 245.328C193.333 242.967 195.454 240.969 198.06 240.969ZM210.242 223.474C213.151 223.474 215.454 225.774 215.454 228.68C215.454 231.525 213.09 233.886 210.242 233.886C207.333 233.886 205.03 231.586 205.03 228.68C204.969 225.774 207.333 223.474 210.242 223.474ZM125.696 221.96C122.787 221.96 120.484 224.261 120.484 227.166C120.484 230.012 122.848 232.373 125.696 232.373C128.606 232.373 130.909 230.072 130.909 227.166C130.909 224.261 128.545 221.96 125.696 221.96ZM199.515 212.637C201.212 212.637 202.606 214.03 202.606 215.725C202.606 217.42 201.212 218.812 199.515 218.812C197.818 218.812 196.424 217.42 196.424 215.725C196.424 214.03 197.757 212.637 199.515 212.637ZM136.727 210.155C135.03 210.155 133.636 211.548 133.636 213.243C133.636 214.938 135.03 216.33 136.727 216.33C138.424 216.33 139.818 214.938 139.818 213.243C139.818 211.487 138.424 210.155 136.727 210.155ZM208.666 188.18C212.606 188.18 215.757 191.328 215.757 195.263C215.757 199.138 212.606 202.346 208.666 202.346C204.727 202.346 201.575 199.198 201.575 195.263C201.575 191.328 204.727 188.18 208.666 188.18ZM128.303 188.18C124.363 188.18 121.212 191.328 121.212 195.263C121.212 199.138 124.363 202.346 128.303 202.346C132.242 202.346 135.393 199.198 135.393 195.263C135.393 191.328 132.242 188.18 128.303 188.18ZM195.818 178.615C197.515 178.615 198.909 180.008 198.909 181.703C198.909 183.398 197.515 184.79 195.818 184.79C194.121 184.79 192.727 183.398 192.727 181.703C192.727 180.008 194.121 178.615 195.818 178.615ZM141.151 178.615C139.454 178.615 138.06 180.008 138.06 181.703C138.06 183.398 139.454 184.79 141.151 184.79C142.848 184.79 144.242 183.398 144.242 181.703C144.242 180.008 142.848 178.615 141.151 178.615Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.364 156.64H135.031C127.273 182.792 121.273 208.763 121.273 226.44C121.273 257.556 142.425 273.78 168.607 273.78C194.789 273.78 216.122 257.617 216.122 226.44C216.122 208.823 210.122 182.852 202.364 156.64Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.849 156.64H135.031C127.273 182.792 121.273 208.763 121.273 226.44C121.273 240.242 125.455 252.895 132.425 262.702C128.486 253.863 126.243 243.693 126.243 232.857C126.243 215.301 131.94 183.942 140.849 156.64Z",
    fill: "#9D6E51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 156,
    width: 96,
    height: 118
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M202.364 156.641H135.031C127.273 182.793 121.273 208.764 121.273 226.441C121.273 257.557 142.425 273.781 168.607 273.781C194.789 273.781 216.122 257.618 216.122 226.441C216.122 208.824 210.122 182.853 202.364 156.641Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.911 142.596C187.699 162.21 194.85 202.104 194.85 215.604C194.85 235.279 183.881 247.568 168.729 247.568C153.638 247.568 142.184 235.279 142.184 215.604C142.184 202.104 149.274 162.21 154.062 142.596H182.911Z",
    fill: "#EFD36F"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M149.212 10.1387L141.637 12.1364L148.364 37.3806L155.879 35.3829L149.212 10.1387Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 10,
    width: 15,
    height: 28
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M149.212 10.1387L141.637 12.1364L148.364 37.3806L155.879 35.3829L149.212 10.1387Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.516 12.8629L143.94 10.623L150.667 35.9278L142.243 38.1072L135.516 12.8629Z",
    fill: "#CE8710"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M144.668 -1C149.577 -1 153.577 2.99549 153.577 7.89904C153.577 12.8026 149.577 16.7981 144.668 16.7981C139.758 16.7981 135.758 12.8026 135.758 7.89904C135.698 2.99549 139.698 -1 144.668 -1Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: -1,
    width: 19,
    height: 18
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.668 -1C149.577 -1 153.577 2.99549 153.577 7.89904C153.577 12.8026 149.577 16.7981 144.668 16.7981C139.758 16.7981 135.758 12.8026 135.758 7.89904C135.698 2.99549 139.698 -1 144.668 -1Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.638 1.60357C144.002 2.02734 143.153 3.29863 141.82 4.44884C140.487 5.59906 139.093 6.20444 138.729 5.84121C138.365 5.41745 139.214 4.14616 140.547 2.99594C141.881 1.78519 143.274 1.17981 143.638 1.60357Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: -1,
    width: 19,
    height: 18
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M144.668 -1C149.577 -1 153.577 2.99549 153.577 7.89904C153.577 12.8026 149.577 16.7981 144.668 16.7981C139.758 16.7981 135.758 12.8026 135.758 7.89904C135.698 2.99549 139.698 -1 144.668 -1Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.303 3.29785C153.091 4.62968 153.576 6.20366 153.576 7.89872C153.576 12.8023 149.576 16.7978 144.667 16.7978C140.667 16.7978 137.273 14.1341 136.121 10.5624C137.697 13.1655 140.545 14.8606 143.757 14.8606C148.667 14.8606 152.667 10.8651 152.667 5.96151C152.667 4.99291 152.545 4.14538 152.303 3.29785Z",
    fill: "#301007"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M188.182 10.1387L195.758 12.1364L189.091 37.3806L181.516 35.3829L188.182 10.1387Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 10,
    width: 15,
    height: 28
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M188.182 10.1387L195.758 12.1364L189.091 37.3806L181.516 35.3829L188.182 10.1387Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.88 12.8629L193.456 10.623L186.789 35.9278L195.213 38.1072L201.88 12.8629Z",
    fill: "#CE8710"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M192.788 -1C187.879 -1 183.879 2.99549 183.879 7.89904C183.879 12.8026 187.879 16.7981 192.788 16.7981C197.697 16.7981 201.697 12.8026 201.697 7.89904C201.697 2.99549 197.697 -1 192.788 -1Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: -1,
    width: 19,
    height: 18
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M192.788 -1C187.879 -1 183.879 2.99549 183.879 7.89904C183.879 12.8026 187.879 16.7981 192.788 16.7981C197.697 16.7981 201.697 12.8026 201.697 7.89904C201.697 2.99549 197.697 -1 192.788 -1Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.756 1.60357C193.393 2.02734 194.241 3.29863 195.575 4.44884C196.908 5.59906 198.302 6.20444 198.665 5.84121C199.029 5.41745 198.181 4.14616 196.847 2.99594C195.514 1.78519 194.12 1.17981 193.756 1.60357Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: -1,
    width: 19,
    height: 18
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M192.788 -1C187.879 -1 183.879 2.99549 183.879 7.89904C183.879 12.8026 187.879 16.7981 192.788 16.7981C197.697 16.7981 201.697 12.8026 201.697 7.89904C201.697 2.99549 197.697 -1 192.788 -1Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.089 3.29785C184.301 4.62968 183.816 6.20366 183.816 7.89872C183.816 12.8023 187.816 16.7978 192.725 16.7978C196.725 16.7978 200.119 14.1341 201.271 10.5624C199.695 13.1655 196.847 14.8606 193.635 14.8606C188.725 14.8606 184.725 10.8651 184.725 5.96151C184.725 4.99291 184.847 4.14538 185.089 3.29785Z",
    fill: "#301007"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M194.243 40.6498C194.183 41.1946 194.668 39.6206 194.91 39.1363C195.456 38.1072 196.122 37.1386 196.728 36.17C198.547 33.4458 200.486 30.7216 202.547 28.179C208.85 20.4907 216.971 14.4975 225.88 10.0783C228.365 8.8675 233.031 5.84061 235.759 7.89889C239.456 10.7442 236.243 21.4593 235.092 24.9705C231.153 36.7754 217.334 49.1251 203.577 49.3672L194.243 40.6498Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 7,
    width: 44,
    height: 43
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M194.243 40.6498C194.183 41.1946 194.668 39.6206 194.91 39.1363C195.456 38.1072 196.122 37.1386 196.728 36.17C198.547 33.4458 200.486 30.7216 202.547 28.179C208.85 20.4907 216.971 14.4975 225.88 10.0783C228.365 8.8675 233.031 5.84061 235.759 7.89889C239.456 10.7442 236.243 21.4593 235.092 24.9705C231.153 36.7754 217.334 49.1251 203.577 49.3672L194.243 40.6498Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.182 3.78278C234.242 3.35902 234.727 4.4487 234.969 4.87246C235.394 5.59891 235.636 6.44644 235.879 7.23343C236.485 9.65494 236.848 12.2581 236.424 14.6796C235.091 22.0652 230.606 28.3611 225.515 33.7489C223.818 35.5045 222.06 37.2601 220.182 38.8946C218.06 40.7108 215.879 42.4664 213.394 43.7377C212.909 43.9798 211.515 44.8879 210.909 44.7063C210.06 44.4641 209.03 42.5269 208.424 41.9215C206.06 39.5606 203.091 37.8655 200 36.6548C199.394 36.4126 197.576 35.5045 196.848 35.8072C196.727 35.8678 199.091 38.2287 199.212 38.4103C200.727 40.0449 202.182 41.7399 203.515 43.556C205.757 46.5224 207.757 49.6704 209.272 53.0605C209.576 53.7264 210.303 56.7533 211.091 57.056C211.879 57.3586 214.121 55.603 214.666 55.3004C218.424 53.0605 221.939 50.5784 225.212 47.7937C234 40.3475 239.879 29.6324 241.394 18.2513C242.182 12.3791 241.333 5.59891 237.212 0.998047L234.182 3.78278Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 7,
    width: 44,
    height: 43
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M194.243 40.6498C194.183 41.1946 194.668 39.6206 194.91 39.1363C195.456 38.1072 196.122 37.1386 196.728 36.17C198.547 33.4458 200.486 30.7216 202.547 28.179C208.85 20.4907 216.971 14.4975 225.88 10.0783C228.365 8.8675 233.031 5.84061 235.759 7.89889C239.456 10.7442 236.243 21.4593 235.092 24.9705C231.153 36.7754 217.334 49.1251 203.577 49.3672L194.243 40.6498Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.242 47.4298C196.121 47.3087 197.515 45.3715 197.636 45.2504C199.272 42.8894 201.09 40.7101 202.969 38.5913C208.121 32.7191 214.181 26.968 221.03 23.3963C221.939 22.912 222.909 22.4277 223.939 22.0645C225.939 21.2775 229.272 20.7326 228.545 24.1228C228.424 24.6676 228.242 25.1519 228.06 25.6967C226.605 29.329 224.06 32.598 221.393 35.3222C218.909 37.8648 215.939 39.8626 212.969 41.6787C208.605 44.3423 203.939 45.9163 199.272 47.9141L196.242 47.4298Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 21,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 21,
    width: 33,
    height: 27
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M196.242 47.4298C196.121 47.3087 197.515 45.3715 197.636 45.2504C199.272 42.8894 201.09 40.7101 202.969 38.5913C208.121 32.7191 214.181 26.968 221.03 23.3963C221.939 22.912 222.909 22.4277 223.939 22.0645C225.939 21.2775 229.272 20.7326 228.545 24.1228C228.424 24.6676 228.242 25.1519 228.06 25.6967C226.605 29.329 224.06 32.598 221.393 35.3222C218.909 37.8648 215.939 39.8626 212.969 41.6787C208.605 44.3423 203.939 45.9163 199.272 47.9141L196.242 47.4298Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.243 40.6498C194.183 41.1946 194.668 39.6206 194.91 39.1363C195.456 38.1072 196.122 37.1386 196.728 36.17C198.547 33.4458 200.486 30.7216 202.547 28.179C208.85 20.4907 216.971 14.4975 225.88 10.0783C228.365 8.8675 233.031 5.84061 235.759 7.89889C239.456 10.7442 236.243 21.4593 235.092 24.9705C231.153 36.7754 217.334 49.1251 203.577 49.3672L194.243 40.6498Z",
    fill: "white"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.182 3.7818C234.242 3.35804 234.727 4.44772 234.969 4.87148C235.394 5.59794 235.636 6.44546 235.879 7.23245C236.485 9.65396 236.848 12.2571 236.424 14.6786C235.091 22.0642 230.606 28.3601 225.515 33.748C223.818 35.5036 222.06 37.2592 220.182 38.8937C218.06 40.7098 215.879 42.4654 213.394 43.7367C212.909 43.9788 211.515 44.8869 210.909 44.7053C210.06 44.4631 209.03 42.5259 208.424 41.9206C206.06 39.5596 203.091 37.8645 200 36.6538C199.394 36.4116 197.576 35.5036 196.848 35.8062C196.727 35.8668 199.091 38.2278 199.212 38.4094C200.727 40.0439 202.182 41.7389 203.515 43.5551C205.757 46.5214 207.757 49.6694 209.272 53.0595C209.576 53.7254 210.303 56.7523 211.091 57.055C211.879 57.3577 214.121 55.6021 214.666 55.2994C218.424 53.0595 221.939 50.5774 225.212 47.7927C234 40.3466 239.879 29.6314 241.394 18.2503C242.182 12.3782 241.333 5.59794 237.212 0.99707L234.182 3.7818Z",
    fill: "#EEC18F"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.153 40.6498C143.214 41.1946 142.729 39.6206 142.486 39.1363C141.941 38.1072 141.274 37.1386 140.668 36.17C138.85 33.4458 136.911 30.7216 134.85 28.179C128.547 20.4907 120.426 14.4975 111.517 10.0783C109.032 8.8675 104.365 5.84061 101.638 7.89889C97.9408 10.7442 101.153 21.4593 102.304 24.9705C106.244 36.7754 120.062 49.1251 133.82 49.3672L143.153 40.6498Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 7,
    width: 45,
    height: 43
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M143.153 40.6498C143.214 41.1946 142.729 39.6206 142.486 39.1363C141.941 38.1072 141.274 37.1386 140.668 36.17C138.85 33.4458 136.911 30.7216 134.85 28.179C128.547 20.4907 120.426 14.4975 111.517 10.0783C109.032 8.8675 104.365 5.84061 101.638 7.89889C97.9408 10.7442 101.153 21.4593 102.304 24.9705C106.244 36.7754 120.062 49.1251 133.82 49.3672L143.153 40.6498Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.213 3.78275C103.153 3.35899 102.668 4.44867 102.426 4.87243C102.001 5.59888 101.759 6.44641 101.516 7.2334C100.91 9.65491 100.547 12.258 100.971 14.6795C102.304 22.0651 106.789 28.3611 111.88 33.7489C113.577 35.5045 115.335 37.2601 117.213 38.8946C119.335 40.7107 121.516 42.4663 124.001 43.7376C124.486 43.9798 125.88 44.8878 126.486 44.7062C127.335 44.4641 128.365 42.5269 128.971 41.9215C131.335 39.5605 134.304 37.8655 137.395 36.6547C138.001 36.4126 139.819 35.5045 140.547 35.8072C140.668 35.8677 138.304 38.2287 138.183 38.4103C136.668 40.0448 135.213 41.7399 133.88 43.556C131.638 46.5224 129.638 49.6703 128.123 53.0604C127.819 53.7263 127.092 56.7532 126.304 57.0559C125.516 57.3586 123.274 55.603 122.729 55.3003C118.971 53.0604 115.456 50.5784 112.183 47.7937C103.456 40.1659 97.5771 29.5113 96.0619 18.0696C95.274 12.1975 96.1225 5.41727 100.244 0.816406L103.213 3.78275Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 7,
    width: 45,
    height: 43
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M143.153 40.6498C143.214 41.1946 142.729 39.6206 142.486 39.1363C141.941 38.1072 141.274 37.1386 140.668 36.17C138.85 33.4458 136.911 30.7216 134.85 28.179C128.547 20.4907 120.426 14.4975 111.517 10.0783C109.032 8.8675 104.365 5.84061 101.638 7.89889C97.9408 10.7442 101.153 21.4593 102.304 24.9705C106.244 36.7754 120.062 49.1251 133.82 49.3672L143.153 40.6498Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.151 47.4298C141.272 47.3087 139.878 45.3715 139.757 45.2504C138.121 42.8894 136.303 40.7101 134.424 38.5913C129.272 32.7191 123.212 26.968 116.363 23.3963C115.454 22.912 114.484 22.4277 113.454 22.0645C111.454 21.2775 108.121 20.7326 108.848 24.1228C108.969 24.6676 109.151 25.1519 109.333 25.6967C110.787 29.329 113.333 32.598 116 35.3222C118.484 37.8648 121.454 39.8626 124.424 41.6787C128.787 44.3423 133.454 45.9163 138.121 47.9141L141.151 47.4298Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 21,
    width: 34,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 21,
    width: 34,
    height: 27
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M141.151 47.4298C141.272 47.3087 139.878 45.3715 139.757 45.2504C138.121 42.8894 136.303 40.7101 134.424 38.5913C129.272 32.7191 123.212 26.968 116.363 23.3963C115.454 22.912 114.484 22.4277 113.454 22.0645C111.454 21.2775 108.121 20.7326 108.848 24.1228C108.969 24.6676 109.151 25.1519 109.333 25.6967C110.787 29.329 113.333 32.598 116 35.3222C118.484 37.8648 121.454 39.8626 124.424 41.6787C128.787 44.3423 133.454 45.9163 138.121 47.9141L141.151 47.4298Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.153 40.6498C143.214 41.1946 142.729 39.6206 142.486 39.1363C141.941 38.1072 141.274 37.1386 140.668 36.17C138.85 33.4458 136.911 30.7216 134.85 28.179C128.547 20.4907 120.426 14.4975 111.517 10.0783C109.032 8.8675 104.365 5.84061 101.638 7.89889C97.9408 10.7442 101.153 21.4593 102.304 24.9705C106.244 36.7754 120.062 49.1251 133.82 49.3672L143.153 40.6498Z",
    fill: "white"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.213 3.78178C103.153 3.35801 102.668 4.44769 102.426 4.87145C102.001 5.59791 101.759 6.44544 101.516 7.23243C100.91 9.65393 100.547 12.2571 100.971 14.6786C102.304 22.0642 106.789 28.3601 111.88 33.7479C113.577 35.5035 115.335 37.2591 117.213 38.8936C119.335 40.7098 121.516 42.4654 124.001 43.7367C124.486 43.9788 125.88 44.8869 126.486 44.7053C127.335 44.4631 128.365 42.5259 128.971 41.9205C131.335 39.5596 134.304 37.8645 137.395 36.6537C138.001 36.4116 139.819 35.5035 140.547 35.8062C140.668 35.8668 138.304 38.2277 138.183 38.4093C136.668 40.0439 135.213 41.7389 133.88 43.555C131.638 46.5214 129.638 49.6693 128.123 53.0595C127.819 53.7254 127.092 56.7523 126.304 57.0549C125.516 57.3576 123.274 55.602 122.729 55.2994C118.971 53.0595 115.456 50.5774 112.183 47.7927C103.456 40.1649 97.5771 29.5103 96.0619 18.0687C95.274 12.1965 96.1225 5.41629 100.244 0.81543L103.213 3.78178Z",
    fill: "#EEC18F"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M168.426 176.436C145.759 176.739 95.8802 156.459 105.395 105.668C118.91 33.3253 145.517 28.3007 168.729 27.6953H169.274C192.304 28.3612 218.668 33.8702 232.062 105.668C241.577 156.701 191.274 176.921 168.729 176.436H168.426Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 27,
    width: 130,
    height: 150
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.426 176.436C145.759 176.739 95.8802 156.459 105.395 105.668C118.91 33.3253 145.517 28.3007 168.729 27.6953H169.274C192.304 28.3612 218.668 33.8702 232.062 105.668C241.577 156.701 191.274 176.921 168.729 176.436H168.426Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.789 56.7534C134.668 30.7222 152.547 28.1191 168.668 27.7559H169.213C185.213 28.2402 202.85 31.0249 216.547 56.7534C202.607 33.628 185.153 31.0249 169.213 30.5406H168.668C152.607 30.9644 134.91 33.3253 120.789 56.7534Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 27,
    width: 130,
    height: 150
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M168.426 176.436C145.759 176.739 95.8802 156.459 105.395 105.668C118.91 33.3253 145.517 28.3007 168.729 27.6953H169.274C192.304 28.3612 218.668 33.8702 232.062 105.668C241.577 156.701 191.274 176.921 168.729 176.436H168.426Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.7 58.8115C115.215 69.1635 111.215 82.6634 108.003 100.219C107.578 102.399 107.336 104.517 107.154 106.576C106.366 108.695 105.882 111.056 105.882 113.719C105.882 153.129 134.003 170.382 168.669 170.382C203.336 170.382 231.457 153.129 231.457 113.719C231.457 111.116 231.033 108.755 230.185 106.636C230.003 104.578 229.7 102.399 229.336 100.219C226.124 82.6634 222.185 69.224 217.639 58.8115C223.215 69.9505 228.124 85.0849 231.942 105.668C232.366 107.908 232.669 110.087 232.851 112.206C233.7 114.385 234.124 116.746 234.124 119.47C234.124 159.788 204.791 177.405 168.609 177.405C132.427 177.405 103.215 159.788 103.215 119.47C103.215 116.807 103.7 114.385 104.548 112.206C104.73 110.087 105.033 107.968 105.457 105.728C109.215 85.0849 114.124 69.9505 119.7 58.8115Z",
    fill: "#CE8710"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M169.09 92.7119C189.817 92.7119 234.241 93.1962 234.241 119.47C234.241 159.788 204.908 177.404 168.726 177.404C132.544 177.404 103.211 159.788 103.211 119.47C103.211 92.7725 148.362 92.7119 169.09 92.7119Z",
    fill: "#F6DCBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_197_181193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 92,
    width: 132,
    height: 86
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M169.09 92.7119C189.817 92.7119 234.241 93.1962 234.241 119.47C234.241 159.788 204.908 177.404 168.726 177.404C132.544 177.404 103.211 159.788 103.211 119.47C103.211 92.7725 148.362 92.7119 169.09 92.7119Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_197_181193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.696 58.8105C115.211 69.1625 111.211 82.6624 107.999 100.218C107.575 102.398 107.332 104.516 107.15 106.575C106.362 108.694 105.878 111.055 105.878 113.718C105.878 153.128 133.999 170.382 168.665 170.382C203.332 170.382 231.453 153.128 231.453 113.718C231.453 111.115 231.029 108.754 230.181 106.635C229.999 104.577 229.696 102.398 229.332 100.218C226.12 82.6624 222.181 69.223 217.635 58.8105C223.211 69.9495 228.12 85.0839 231.938 105.667C232.362 107.907 232.665 110.086 232.847 112.205C233.696 114.384 234.12 116.745 234.12 119.469C234.12 159.787 204.787 177.404 168.605 177.404C132.423 177.404 103.211 159.787 103.211 119.469C103.211 116.806 103.696 114.384 104.544 112.205C104.726 110.086 105.029 107.967 105.453 105.727C109.211 85.0839 114.12 69.9495 119.696 58.8105Z",
    fill: "#EEC18F"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.426 35.8672C150.911 35.8672 152.911 37.8649 152.911 40.347C152.911 42.829 150.911 44.8268 148.426 44.8268C145.941 44.8268 143.941 42.829 143.941 40.347C143.941 37.8649 145.941 35.8672 148.426 35.8672Z",
    fill: "#673620"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.305 44.8271C174.79 44.8271 176.79 46.8249 176.79 49.3069C176.79 51.789 174.79 53.7867 172.305 53.7867C169.82 53.7867 167.82 51.789 167.82 49.3069C167.82 46.8249 169.82 44.8271 172.305 44.8271Z",
    fill: "#673620"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.181 35.8672C192.242 35.8672 193.878 37.5017 193.878 39.56C193.878 41.6183 192.242 43.2528 190.181 43.2528C188.121 43.2528 186.484 41.6183 186.484 39.56C186.484 37.5017 188.121 35.8672 190.181 35.8672Z",
    fill: "#673620"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.88 32.4166C164.668 32.0533 167.274 34.1116 167.638 37.0174C168.001 39.9232 166.062 42.5869 163.274 42.9501C160.486 43.3133 157.88 41.2551 157.516 38.3492C157.153 35.4434 159.092 32.7798 161.88 32.4166Z",
    fill: "#673620"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.184 52.8184C161.699 52.8184 162.912 54.0291 162.912 55.5426C162.912 57.056 161.699 58.2668 160.184 58.2668C158.669 58.2668 157.457 57.056 157.457 55.5426C157.457 54.0897 158.669 52.8184 160.184 52.8184Z",
    fill: "#673620"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.061 46.3401C158.909 46.4612 159.576 47.1876 159.455 48.0957C159.334 48.9432 158.606 49.6091 157.697 49.4881C156.849 49.367 156.182 48.6405 156.303 47.7325C156.425 46.8849 157.212 46.2796 158.061 46.3401Z",
    fill: "#673620"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.181 40.5898C181.03 40.5898 181.757 41.3163 181.757 42.1638C181.757 43.0114 181.03 43.7378 180.181 43.7378C179.333 43.7378 178.605 43.0114 178.605 42.1638C178.605 41.3163 179.333 40.5898 180.181 40.5898Z",
    fill: "#673620"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.638 55.2393C178.487 55.2393 179.214 55.9657 179.214 56.8132C179.214 57.6608 178.487 58.3872 177.638 58.3872C176.79 58.3872 176.063 57.6608 176.063 56.8132C176.062 55.9657 176.79 55.2393 177.638 55.2393Z",
    fill: "#673620"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.001 32.2354C177.516 32.2354 178.728 33.4461 178.728 34.9595C178.728 36.473 177.516 37.6837 176.001 37.6837C174.486 37.6837 173.273 36.473 173.273 34.9595C173.273 33.4461 174.486 32.2354 176.001 32.2354Z",
    fill: "#673620"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.727 48.7012C150 48.7012 150.969 49.7303 150.969 50.9411C150.969 52.2124 149.939 53.181 148.727 53.181C147.454 53.181 146.484 52.1518 146.484 50.9411C146.484 49.6698 147.515 48.7012 148.727 48.7012Z",
    fill: "#673620"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.728 59.0537C170.789 59.0537 172.425 60.6882 172.425 62.7465C172.425 64.8048 170.789 66.4393 168.728 66.4393C166.668 66.4393 165.031 64.8048 165.031 62.7465C165.031 60.6882 166.668 59.0537 168.728 59.0537Z",
    fill: "#673620"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.637 47.4902C187.092 47.4902 188.243 48.6405 188.243 50.0934C188.243 51.5463 187.092 52.6965 185.637 52.6965C184.183 52.6965 183.031 51.5463 183.031 50.0934C183.031 48.6405 184.243 47.4902 185.637 47.4902Z",
    fill: "#673620"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.788 105.062C131.091 105.062 136.182 107.363 136.182 110.148C136.182 112.932 131.091 115.233 124.788 115.233C118.485 115.233 113.395 112.932 113.395 110.148C113.455 107.302 118.546 105.062 124.788 105.062Z",
    fill: "#E96565"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.605 104.76C218.908 104.76 223.999 107.06 223.999 109.845C223.999 112.63 218.908 114.93 212.605 114.93C206.302 114.93 201.211 112.63 201.211 109.845C201.211 107 206.302 104.76 212.605 104.76Z",
    fill: "#E96565"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.516 103.488C155.152 102.822 157.576 104.517 158.97 107.241C160.364 109.965 160.182 112.75 158.607 113.416C156.97 114.082 154.546 112.387 153.152 109.662C151.758 106.938 151.94 104.154 153.516 103.488Z",
    fill: "#301007"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.88 103.488C182.244 102.822 179.82 104.517 178.426 107.241C177.032 109.965 177.213 112.75 178.789 113.416C180.426 114.082 182.85 112.387 184.244 109.662C185.638 106.938 185.516 104.154 183.88 103.488Z",
    fill: "#301007"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.213 57.4189C152.365 57.4189 159.759 64.9256 159.759 74.1879C159.759 83.4501 152.365 90.9568 143.213 90.9568C134.062 90.9568 126.668 83.4501 126.668 74.1879C126.668 64.9256 134.123 57.4189 143.213 57.4189Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.213 63.1094C149.88 63.1094 155.274 68.5578 155.274 75.2774C155.274 81.9971 149.88 87.4455 143.213 87.4455C136.546 87.4455 131.152 81.9971 131.152 75.2774C131.213 68.6183 136.607 63.1094 143.213 63.1094Z",
    fill: "#301007"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.696 66.7413C146.605 66.0754 148.423 67.044 149.817 68.9207C151.211 70.7973 151.635 72.8556 150.726 73.5215C149.817 74.1875 147.999 73.2189 146.605 71.3422C145.211 69.4655 144.847 67.4072 145.696 66.7413Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.029 75.5195C152.059 75.5195 152.847 76.3671 152.847 77.3357C152.847 78.3648 152.059 79.1518 151.029 79.1518C149.999 79.1518 149.211 78.3043 149.211 77.3357C149.211 76.3671 150.059 75.5195 151.029 75.5195Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.182 57.4189C203.334 57.4189 210.728 64.9256 210.728 74.1879C210.728 83.4501 203.334 90.9568 194.182 90.9568C185.031 90.9568 177.637 83.4501 177.637 74.1879C177.637 64.9256 185.031 57.4189 194.182 57.4189Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.182 63.1094C200.848 63.1094 206.242 68.5578 206.242 75.2774C206.242 81.9971 200.848 87.4455 194.182 87.4455C187.515 87.4455 182.121 81.9971 182.121 75.2774C182.182 68.6183 187.576 63.1094 194.182 63.1094Z",
    fill: "#301007"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.668 66.7413C197.578 66.0754 199.396 67.044 200.79 68.9207C202.184 70.7973 202.608 72.8556 201.699 73.5215C200.79 74.1875 198.971 73.2189 197.578 71.3422C196.184 69.4655 195.82 67.4072 196.668 66.7413Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.002 75.5195C203.032 75.5195 203.82 76.3671 203.82 77.3357C203.82 78.3648 203.032 79.1518 202.002 79.1518C200.971 79.1518 200.184 78.3043 200.184 77.3357C200.184 76.3671 201.032 75.5195 202.002 75.5195Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.968 145.804C152.423 147.862 154.665 149.375 157.514 150.465C158.544 150.889 159.696 151.131 160.908 151.373C163.271 151.797 165.817 151.918 168.544 151.615C172.059 151.252 175.696 150.102 179.332 148.528C184.181 146.409 188.908 143.322 193.15 139.447C193.453 139.205 193.514 138.781 193.271 138.478C193.029 138.176 192.605 138.115 192.302 138.357C189.211 140.476 185.938 142.171 182.605 143.503C179.09 144.956 175.574 145.925 172.241 146.53C170.423 146.893 168.665 147.075 166.968 147.256C165.15 147.438 163.393 147.62 161.696 147.559C160.241 147.559 158.847 147.438 157.514 147.196C155.211 146.772 153.271 146.106 151.696 144.895C151.514 144.714 151.15 144.653 150.968 144.895C150.787 145.259 150.787 145.561 150.968 145.804Z",
    fill: "#301007"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_181193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_197_181193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 322,
    fill: "white",
    transform: "translate(52 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiraffeOk);
export default __webpack_public_path__ + "static/media/giraffe_ok.0e5f9179e483e7803e98787b8ec596cf.svg";
export { ForwardRef as ReactComponent };